<!--
*  TTTech nerve-ui-components
*  Copyright(c) 2021. TTTech Industrial Automation AG.
*
*  ALL RIGHTS RESERVED.
*
*  Usage of this software, including source code, netlists, documentation,
*  is subject to restrictions and conditions of the applicable license
*  agreement with TTTech Industrial Automation AG or its affiliates.
*
*  All trademarks used are the property of their respective owners.
*
*  TTTech Industrial Automation AG and its affiliates do not assume any liability
*  arising out of the application or use of any product described or shown
*  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
*  make changes, at any time, in order to improve reliability, function or
*  design.
*
*  Contact Information:
*  support@tttech-industrial.com
*
*  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
*
* -->
<template>
  <div>
    <nerve-button
      id="iiotUpdateDeployedWorkloadDialog"
      :class="{ 'ma-0': isLocalUi }"
      :text="$t('nodes.deployedWorkloadControl.updateBtn')"
      type-of-btn="action"
      size="normal"
      @click-event="updateBtnClicked"
    />
  </div>
</template>

<script>
import NerveButton from '../NerveButton.vue';

export default {
  components: {
    NerveButton,
  },
  props: {
    versionsOfWorkload: {
      type: Number,
      default: 0,
    },
    isLocalUi: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateBtnClicked() {
      this.$emit('update-btn-clicked');
    },
  },
};
</script>

<style lang="scss" scoped>
.update-button-position {
  margin-bottom: 9px;
}
</style>
